import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { changeThemeName } from "../../ducks/theme/theme";
import { getThemeName } from "../../ducks/theme/selectors";
import { useProjectBaseMapName, useProjectUpdate } from "../../ducks/project/hooks";
import { useWidgetConfiguration } from "../../modules/Dashboard/hooks/useWidgetConfiguration";
import { useIsDashboard } from "../location/useIsDashboard";
import { WidgetType } from "../../modules/FeatureCard/types";

export const useDashboardPageOptions = () => {
  const dispatch = useDispatch();
  const isDashboard = useIsDashboard();
  const themeName = useSelector(getThemeName);
  const baseMapName = useProjectBaseMapName();
  const { currentConfig } = useWidgetConfiguration(WidgetType.Dashboard);
  const mutation = useProjectUpdate();
  const defaultThemeName = useRef(themeName);

  const configBaseMapName = currentConfig.options?.baseMapName;
  const configThemeName = currentConfig.options?.themeName;

  useEffect(() => {
    (async () => {
      if (!isDashboard) {
        return;
      }

      await mutation({
        content: {
          baseMapName: configBaseMapName || baseMapName,
        },
      });
    })();
  }, [configBaseMapName]);

  useEffect(() => {
    dispatch(changeThemeName(configThemeName || defaultThemeName.current));
  }, [configThemeName]);
};
